import React from 'react'
import styles from "./UserOnboardingSteps.module.css"

const UserOnboardingSteps = ({ stepNo }) => {
  const registrationSteps = [
    { id: 1, stepName: "Jurisdiction" },
    { id: 2, stepName: "Entity Details" },
    { id: 3, stepName: "Confirmation" }
  ]

  return (
    <div className={styles.StepsBox}>
      {registrationSteps.map((step) => {
        const isCompleted = stepNo > step.id;
        const isActive = stepNo === step.id;
        const isLast = step.id === registrationSteps.length;

        return (
          <div className={styles.Step} key={step.id}>
            <div className={styles.stepContainer}>
              <div className={`${styles.stepNumber}
                ${isCompleted ? styles.completedStepNumber : ""}
                ${isActive ? styles.activeStepNumber : ""}`}>
                {isCompleted ? "✓" : step.id}
              </div>
              <div className={`${styles.StepName}
                ${isCompleted ? styles.completedStepName : ""}
                ${isActive ? styles.activeStepName : ""}`}>
                {step.stepName}
              </div>
            </div>
            {!isLast && <div className={styles.line} />}
          </div>
        )
      })}
    </div>
  )
}

export default UserOnboardingSteps